import React, { useContext, useRef } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import classNames from 'classnames';

import navMenuManager from '../../managers/NavMenuManager';

import useAccessibilityClick from '../../../hooks/useAccessibilityClick';

import HtmlComponent from '../HtmlComponent';
import VerticalGotoItem from './VerticalGotoItem';

import utils from '../../services/UtilsService';

/**
 * A collapsible "Lesson Section" group inside the vertical GO TO menu.
 *
 * @param {string} sectionLessonElementId
 * @param {{ lessonElementId: string, itemNumber: number|null, isLocked: boolean, childState: object|null }[]} items
 */
const VerticalGotoSection = observer(({ sectionLessonElementId, items }) => {
  const {
    lessonManager
  } = useContext(MobXProviderContext);

  const toggleRef = useRef();
  const section = lessonManager.getSectionModel(sectionLessonElementId);
  const sectionTitle = (!utils.isNullOrEmpty(section?.title))
    ? section.title
    : (section?.sectionNumber ? `Section ${section.sectionNumber}` : '');
  const collapsed = navMenuManager.isVerticalGotoSectionCollapsed(sectionLessonElementId);

  useAccessibilityClick(toggleRef, () => {
    navMenuManager.toggleVerticalGotoSection(sectionLessonElementId);
  });

  if (!items || items.length === 0) {
    return (<></>);
  }

  return (
    <div className={classNames('vertical-goto-section', { collapsed })}>
      <div
        ref={toggleRef}
        aria-expanded={!collapsed}
        className='vertical-goto-section-header'
        role='button'
        tabIndex='0'>
        <span aria-hidden='true' className={classNames('vertical-goto-section-caret', { collapsed })} />
        <span className='vertical-goto-section-title'>
          <HtmlComponent ariaHidden={true} htmlStr={sectionTitle} />
        </span>
      </div>
      {!collapsed && (
        <ol className='vertical-goto-item-list'>
          {items.map(({ lessonElementId, itemNumber, isLocked, childState }) => (
            <VerticalGotoItem
              key={`${lessonElementId}-vertical-goto-item`}
              childState={childState}
              isLocked={isLocked}
              itemNumber={itemNumber}
              lessonElementId={lessonElementId} />
          ))}
        </ol>
      )}
    </div>
  );
});

export default VerticalGotoSection;
